
import React from "react";
import { Control } from "react-hook-form";
import EmailField from "./EmailField";
import PasswordField from "./PasswordField";

interface LoginFormFieldsProps {
  control: Control<any>;
}

const LoginFormFields: React.FC<LoginFormFieldsProps> = ({ control }) => {
  return (
    <>
      <EmailField control={control} />
      <PasswordField 
        control={control} 
        forgotPasswordLink={() => {}} // This is unused since we handle this in the parent
      />
    </>
  );
};

export default LoginFormFields;
